import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { DocumentCostSummarySection } from "../../../../../components/Proposal&Contracts/DocumentCostSummarySection.tsx"
import { type ProposalFormData } from "../proposal-form-data.tsx"

export const defaultProposalFormCostSummary: ProposalFormData["cost_summary"] =
  {
    line_items: [
      {
        item: "Labor",
        description: "Professional installation services",
        amount: 45000
      },
      {
        item: "Rough Materials",
        description: "Lumber, drywall, insulation, etc.",
        amount: 28000
      },
      {
        item: "Permits / Fees",
        description: "City permits and inspections",
        amount: 3500
      },
      {
        item: "Subcontractors",
        description: "Specialized trades",
        amount: 12000
      }
    ],
    subtotal: 88500,
    discount_description: "Discount",
    discount_amount: 3500,
    total: 85000
  }

interface ProposalCostSummarySectionProps {
  form: FormInstance<ProposalFormData>
}

export function ProposalCostSummarySection({
  form
}: ProposalCostSummarySectionProps) {
  return <DocumentCostSummarySection form={form} />
}
